/* src/pages/accessible-step-management/page-accessible-step-management.component.scss */
.card-container {
  display: flex;
  grid-gap: 2rem;
}
.step-list__body {
  --card-padding: 0;
}
.step-list__body:has(.step-item) .empty-state {
  display: none;
}
.item {
  --bg-color: var(--vwui-color-light);
  background-color: var(--bg-color);
  height: 4rem;
  padding: 1rem 1.5rem;
}
.item:not(:last-child) {
  border-bottom: solid 1px var(--vwui-border-color-light);
}
.item--draggable {
  cursor: move;
}
.item--disabled {
  --bg-color: var(--vwui-color-neutral-4);
  cursor: not-allowed;
}
.item.cdk-drag-placeholder {
  z-index: 1;
  border: solid var(--vwui-color-primary) 1px;
}
.cdk-drag-preview {
  border-radius: 0.25rem;
  box-shadow: var(--vwui-shadow-large);
  border: solid 1px var(--vwui-color-primary);
}
.cdk-drag-animating {
  transition: transform 250ms ease-in-out;
}
.step-list__body.cdk-drop-list-dragging .step-item:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
/*# sourceMappingURL=page-accessible-step-management.component-ZLCLQOYT.css.map */
